import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryList(params) {
  return request('/actionSetFormFieldValueMapping/paged', {
    params: toQuery(params),
  });
}

export async function queryEditItemSetFormFieldValue({ id, params }) {
  return request(`/actionSetFormFieldValueMapping/${id}`, {
    params: toQuery(params),
  });
}

export async function queryAddNewSetFormFieldValue(params) {
  return request.post(`/actionSetFormFieldValueMapping`, {
    data: params,
  });
}

export async function queryAddEditSetFormFieldValue(params) {
  return request.put('/actionSetFormFieldValueMapping', {
    data: params,
  });
}

export async function queryDeleteItem(id) {
  return request.delete(`/actionSetFormFieldValueMapping/${id}`, {});
}
